import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@material-ui/core';
import { Share as ShareIcon } from '@material-ui/icons';

const NativeShareButton = ({ title, text, url, tooltip = "Share" }) => {
  const handleNativeShare = useCallback(async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: text,
          url: url,
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
        }
      }
    }
  }, [title, text, url]);

  if (!navigator.share) {
    return null;
  }

  return (
    <Tooltip title={tooltip} arrow>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          handleNativeShare();
        }}
        size="small"
        aria-label={tooltip}
        style={{ padding: '2px', width: '24px', height: '24px' }}
      >
        <ShareIcon style={{ fontSize: '16px' }} />
      </IconButton>
    </Tooltip>
  );
};

export default NativeShareButton;

